import { AnyAction } from 'redux';
import { BUY_BUTTON_SET_ARTICLE_NUMBER, BUY_BUTTON_SET_STOCK_STATUS, BUY_BUTTON_SET_STOCK_STATUSES } from '../constants';
import StockStatus from '../Types/StockStatus';

export interface BuyButtonState {
  articleNumber?: string;
  disabled?: boolean;
  isLoading?: boolean;
  stockStatuses?: { key: string; value: StockStatus };
  stockStatus?: StockStatus;
}

const DEFAULT_STATE: BuyButtonState = {};

export const buyButton = (
  state = DEFAULT_STATE,
  action: AnyAction
): BuyButtonState => {
  switch (action.type) {
    case BUY_BUTTON_SET_ARTICLE_NUMBER:
    case BUY_BUTTON_SET_STOCK_STATUSES:
    case BUY_BUTTON_SET_STOCK_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
